import React from 'react';
import { View, Text, StyleSheet, Alert, Platform, KeyboardAvoidingView, TouchableOpacity, TextInput } from 'react-native';
import CS from '../../constants/Styles';
import TextInputContainer from '../../components/TextInputContainer';
import { Button, Loader, Validate, BackgroundGradient, SafeAreaView, Storage } from '../../components';
import { FontAwesome5 } from '@expo/vector-icons';
import Colors from '../../constants/Colors';
import * as rtApi from '../../components/Api';
import UserState from '../../src/contexts/UserState';
import { processLoginAccount } from '../../utils/Functions';
import { useLinkTo } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const iconSize = 52;

const CreatePasswordScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);

  const [username, setUsername] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [newPasswordLength, setNewPasswordLength] = React.useState(0);
  const [newPasswordLengthValid, setNewPasswordLengthValid] = React.useState(false);
  const [newPasswordConfirm, setNewPasswordConfirm] = React.useState('');
  const [newPasswordConfirmLength, setNewPasswordConfirmLength] = React.useState(0);
  const [newPasswordConfirmLengthValid, setNewPasswordConfirmLengthValid] = React.useState(false);
  const [token, setToken] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const linkTo = useLinkTo();
  const insets = useSafeAreaInsets();

  let textInputs = {
    newPasswordInput: React.useRef(null),
    newPasswordConfirmInput: React.useRef(null),
  };

  const defaultIsInvalid = { newPassword: false, newPasswordConfirm: false };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);

  React.useEffect(() => {
    setUsername(route.params.username);
    setToken(route.params.token);
  }, [route.params.token, route.params.username]);

  const onChangePassword = (input) => {
    if (isInvalid.newPassword && Validate.Password(input)) {
      setIsInvalid(prevState => { return { ...prevState, newPassword: false } });
      textInputs.newPasswordInput.current.focus();
    }
    setNewPassword(input);
    setNewPasswordLength(input.length);
    setNewPasswordLengthValid(input.length >= 15 ? true : false);
  };
  const onChangePasswordConfirm = (input) => {
    if (isInvalid.newPasswordConfirm && Validate.Password(input)) {
      setIsInvalid(prevState => { return { ...prevState, newPasswordConfirm: false } });
      textInputs.newPasswordConfirmInput.current.focus();
    }
    setNewPasswordConfirm(input);
    setNewPasswordConfirmLength(input.length);
    setNewPasswordConfirmLengthValid(input.length >= 15 ? true : false);
  };

  function check() {
    if (!Validate.Password(newPassword)) {
      setIsInvalid(prevState => { return { ...prevState, newPassword: true } });
      Alert.alert('Invalid', 'Please enter a valid password');
      return;
    }
    if (!Validate.Password(newPasswordConfirm)) {
      setIsInvalid(prevState => { return { ...prevState, newPasswordCorfirm: true } });
      Alert.alert('Invalid', 'Please enter a valid password');
      return;
    }
    if(newPassword !== newPasswordConfirm){
      Alert.alert('Invalid', 'Passwords do not match');
      return;
    }
    validate();
  }

  const validate = () => {
    setLoading(true);

    let fd = new FormData();
    fd.append('username', username);
    fd.append('password', newPassword);
    fd.append('password_confirm', newPasswordConfirm);
    fd.append('token', token);

    rtApi.post('login/forgot/validate', fd)
    .then(data => {
      console.log('forgot/validate', data);
      if(data.result){
        processUser(data.session.account);
      }
    }).catch(err => {
      console.log('catch', err);
      if (err.expired) {
        console.log('expired');
        setTimeout(() => { navigation.navigate('ForgotPassword', { resetOccured: false }) }, 100);
      }
    }).finally(err => {
      setLoading(false);
    });
  }

  const processUser = async (u) => {
    // const uname = await SecureStore.getItemAsync('username');
    const uname = await Storage.getItem('username');
    console.log('checkUsernameSecureStore', username, uname);
    if (!uname || (uname !== username)) {
      console.log('deleting useLocalAuthentication');
      // await SecureStore.deleteItemAsync('useLocalAuthentication');
      await Storage.removeItem('useLocalAuthentication');
    }
    await Promise.all([
      // SecureStore.setItemAsync('username', String(username)),
      // SecureStore.setItemAsync('password', String(newPassword)),
      Storage.setItem('username', String(username)),
      Storage.setItem('password', String(newPassword)),
    ]);

    console.log('setting user');
    let user = processLoginAccount(u, false);
    setUser(user);

    return true;
  }

  const goBack = () => {
    if(navigation.canGoBack()){
      navigation.goBack();
    }else{
      linkTo('/login');
    }
  }

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS == "ios" ? "padding" : "height"}
      style={{ flex: 1 }}
    // keyboardVerticalOffset={headerHeight}
    >
      <BackgroundGradient />
      <Loader animating={loading} />
      <SafeAreaView style={CS.safe}>
        <View style={CS.innerContainer}>
          <TouchableOpacity onPress={goBack} style={[styles.backArrow, { paddingTop: insets.top ? 0 : 10}]}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
          <View style={styles.inner}>
            <View style={styles.iconTextContainer}>
              <View style={[styles.iconContainer, { marginRight: 20 }]}>
                <FontAwesome5 name='key' color={Colors.yellow} size={iconSize} style={styles.icon} />
              </View>
              <Text style={[CS.largeTitle, CS.lightText]}>Create new Password</Text>
            </View>
            {/* <Text style={[CS.lightText, CS.smallText]}>username: {username}</Text> */}
            {/* <Text style={[CS.lightText, CS.smallText]}>token: {token}</Text> */}
            {/* <Text style={[CS.lightText, CS.smallText]}>p: {newPassword}</Text> */}
            {/* <Text style={[CS.lightText, CS.smallText]}>p2: {newPasswordConfirm}</Text> */}
            {/* <TextInput
              textContentType='newPassword'
              placeholder='New Password'
              passwordRules="required: lower; required: upper; required: digit; required: [-]; minlength: 15;"
              style={{width: '100%', borderColor: Colors.lightBlue, borderWidth: 1, padding: 10, backgroundColor: Colors.textInputBackground, color: Colors.lightText}}
            /> */}
            <TextInput
              autocomplete="username"
              autoCompleteType='username'
              textContentType='username'
              keyboardType='email-address'
              autoCapitalize='none'
              value={username}
              style={{ position: 'absolute', top: -10000, left: -10000 }}
            />
            <View style={CS.passwordInputContainer}>
              <TextInputContainer
                autoFocus={true}
                iconName='lock'
                placeholder='Password'
                textContentType='newPassword'
                onChangeText={(t) => onChangePassword(t)}
                autoCapitalize='none'
                spellCheck={false}
                onSubmitEditing={() => textInputs.newPasswordConfirmInput.current.focus()}
                returnKeyType='next'
                inputRef={textInputs.newPasswordInput}
                isInvalid={isInvalid.newPassword}
                autocomplete="new-password"
                passwordRules="required: lower; required: upper; required: digit; required: [-]; minlength: 15;"
              />
              <Text style={[CS.smallText, styles.characterCount, (newPasswordLengthValid && styles.validText)]}>{newPasswordLength}</Text>
            </View>
            <View style={CS.passwordInputContainer}>
              <TextInputContainer
                iconName='lock'
                placeholder='Confirm Password'
                textContentType='newPassword'
                onChangeText={(t) => onChangePasswordConfirm(t)}
                autoCapitalize='none'
                spellCheck={false}
                onSubmitEditing={() => check()}
                returnKeyType='done'
                inputRef={textInputs.newPasswordConfirmInput}
                isInvalid={isInvalid.newPasswordConfirm}
                autocomplete="new-password"
                passwordRules="required: lower; required: upper; required: digit; required: [-]; minlength: 15;"
              />
              <Text style={[CS.smallText, styles.characterCount, (newPasswordConfirmLengthValid && styles.validText)]}>{newPasswordConfirmLength}</Text>
            </View>
            <Text style={[CS.lightBlueText, CS.smallText, styles.passwordText]}>We recommend you create a password using a series of 4 random words. It'll be easier for you to remember, but more difficult for hackers. Your password must be a minimum of 15 characters.</Text>
            <Button text='Create' onPress={() => check} />
          </View>
        </View>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );

}

const styles = StyleSheet.create({
  iconTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 40,
  },
  iconContainer: {
    padding: 20,
    borderStyle: 'solid',
    borderWidth: 3,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    // marginTop: 20,
    // marginBottom: 30,
    marginHorizontal: 0,
    // marginRight:20,
    // backgroundColor:'pink'
  },
  icon: {
    shadowColor: Colors.darkGrey,
    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 1,
    shadowRadius: 4,
  },
  title: {
    marginBottom: 40,
    textAlign: 'center',
  },
  messageContainer: {
    width: '100%',
    marginVertical: 40,
    alignItems: 'center',
  },
  message: {
    width: '80%',
    textAlign: 'center',
  },
  or: {
    marginVertical: 10,
  },
  backArrow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    padding: 10,
    zIndex: 10,
  },
  inner: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  passwordText: {
    marginBottom: 20,
  },
  characterCount: {
    position: 'absolute',
    top: 7,
    right: 5,
    color: Colors.red,
    padding: 5,
    backgroundColor: Colors.textInputBackground
  },
  validText: {
    color: Colors.green,
  }
})

export default CreatePasswordScreen;